import React, {useEffect, useState} from 'react';
import {NavBar,  Avatar, Menu, MenuItem, Icons, Section, ButtonLink, Button, Dropdown, Positions, Variants} from '@sede-enterprise/shell-ds-react-framework';
import { AuthService } from '../../services/AuthService';
import { useLocation, useNavigate } from 'react-router-dom';
import './Navstyle.css' 
import { Sliders } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import { postData } from '../../services/ApiService';
import { ApiUrls } from '../../helpers/ApiUrls';
import { Constants } from '../../helpers/Constants';
import { useTranslation } from 'react-i18next';

interface propsInterface{
    user:{
        email: string;
        isActive: boolean;
        name: string;
        roleID: number;
        roleName: string;
        userId: number;
    },
    permissions:[
        {
            canRead: boolean;
            canView: boolean;
            canWrite: boolean;
            permissionId: number;
            permissionName: string;
            roleId: number;
        }
    ]
}
const HorizontalMenu = (props: propsInterface) => {
    const location = useLocation();
    const navigate = useNavigate();
    
    const defaultPermissions = {
        dashboard: {
            canRead: false,
            canView: false,
            canWrite: false
        },
        allTransactions: {
            canRead: false,
            canView: false,
            canWrite: false
        },
        miTransactions:{
            canRead: false,
            canView: false,
            canWrite: false
        },
        miConfig:{
            canRead: false,
            canView: false,
            canWrite: false
        },
        admin:{
            canRead: true,
            canView: true,
            canWrite: true
        },
        report:{
            canRead: false,
            canView: false,
            canWrite: false
        }
    };
    const [navigationPermission, setNavigationPermission] = useState(defaultPermissions);

    useEffect(()=>{
        
        props.permissions.forEach((permission) => {
            switch(permission.permissionName){
                case 'User Management':
                    
                    break;
                case 'MI':
                    if(permission.canView){
                        defaultPermissions.miTransactions.canView = true;
                    }
                    break;
                case 'Admin':
                    if(permission.canView){
                        defaultPermissions.admin.canView = true;
                    }
                    break;
                case 'All transactions':
                    if(permission.canView){
                        defaultPermissions.allTransactions.canView = true;
                    }
                    break;
                case 'Reports':
                    if(permission.canView){
                        defaultPermissions.report.canView = true;
                    }
                    break;
                case 'Dashboard':
                    if(permission.canView){
                        defaultPermissions.dashboard.canView = true;
                    }
                break;

                case 'MI Configuration':
                    if(permission.canView){
                        defaultPermissions.miConfig.canView = true;
                    }
                    break;

            }
        });
        setNavigationPermission(defaultPermissions);
    },[props.permissions])
    
    
    const [selectedLocation, setSelectedLocation] = useState<string>("dashboard");
    const menu = (
        <Menu style={{position:'fixed', backgroundColor: '#FFFFFF', width:'163px'}}>
            {navigationPermission.miTransactions.canView && <MenuItem key="transactoins" onClick={()=>{navigate('/transactions');}}>MI Transactions {navigationPermission.allTransactions.canView}</MenuItem>}
            {navigationPermission.allTransactions.canView && <MenuItem key="allTransactions" onClick={()=>{navigate('/rawdata');}}>All Transactions</MenuItem>}
        </Menu>
    ); 

    useEffect(() => {
        
        if(location.pathname.includes('/dashboard')){
            setSelectedLocation('dashboard');
        }else if(location.pathname.includes('/transactions') || location.pathname.includes('/update') ||  location.pathname.includes('/rawdata') ){
            setSelectedLocation('transactions');
        }else if(location.pathname.includes('/admin')){
            setSelectedLocation('admin');
        }else if(location.pathname.includes('/notification')){
            setSelectedLocation('notification');
        }else if(location.pathname.includes('/miconfiguration')){
            setSelectedLocation('miconfiguration');
        }else if(location.pathname.includes('/report')){
            setSelectedLocation('report');
        }
    }, [location]); 

    return (
    
        <Menu mode="horizontal" selectedKeys={[selectedLocation]} disabledOverflow style={{justifyContent: 'center', width: '100%'}}>
            {
                navigationPermission.dashboard.canView &&
                <MenuItem key="dashboard" onClick={()=>{navigate('/dashboard');}}>
                    <ButtonLink> <Icons.Grid /> DASHBOARD </ButtonLink>
                </MenuItem>
            }
            {
                (navigationPermission.allTransactions.canView || navigationPermission.miTransactions.canView) &&
                <MenuItem key="transactions" >
                    <Dropdown  overlay={menu}>
                        <Button variant={Variants.Transparent} icon={<Icons.Order />} iconPosition={Positions.Left}>
                            TRANSACTIONS
                        </Button>
                    </Dropdown>
                </MenuItem>
            }
            {
                navigationPermission.miConfig.canView &&
                <MenuItem key="miconfiguration" onClick={()=>{navigate('/miconfiguration');}}>
                    <ButtonLink><Sliders/>MI CONFIGURATION</ButtonLink>
                </MenuItem>
            }
            {
                navigationPermission.admin.canView &&
                <MenuItem key="admin" onClick={()=>{navigate('/admin');}}>
                    <ButtonLink><Icons.Gear /> ADMIN</ButtonLink>
                </MenuItem>
            }
            {
                navigationPermission.report.canView &&
                <MenuItem key="report" >
                    <Dropdown  overlay={
                        <Menu style={{position:'fixed', backgroundColor: '#FFFFFF', width:'163px'}}>
                            <MenuItem key="configureReport" onClick={()=>{navigate('/report/configure');}}>Configure Report</MenuItem>
                            <MenuItem key="generateReport" onClick={()=>{navigate('/report/generate');}}>Generate Report</MenuItem>
                        </Menu>
                    }>
                        <Button variant={Variants.Transparent} icon={<Icons.Gear />} iconPosition={Positions.Left}>REPORT</Button>
                    </Dropdown>
                </MenuItem>
            }  
        </Menu>
    )
};

 
export const Navigation = (props: propsInterface) => {
    
    const initialuser = {
        name: '',
        email: '',
        abbreviation: '',
        token: ''
    };
    
    const authService = new AuthService();
    const [user, setUser] = useState(initialuser);
    const navigate = useNavigate();
    const { t } = useTranslation();

    const logout = () =>{
        const url = ApiUrls.logout;
        postData(url, {}).then((response)=>{
            localStorage.clear();
            document.title = `${t('shellAviationAIMS')}`;
            navigate('/');
        }).catch((error)=>{
            console.log("Error:: ", error);
        });
        
    } 

    const MenuOverlay = (
        <Menu>
            <MenuItem key="logout" onClick={()=>{logout();}} style={{padding: '12px 80px'}}>Logout</MenuItem>
        </Menu>
    );

      
    useEffect(() => {
        getUser();
        return () => {
            //Will unmount
        };
    }, []);

    const getUser = () => {
        authService.getUser().then(userObj => {
            if (!userObj) {
                alert('You are not logged in.');

            }else{
                const firstName  = JSON.stringify(userObj.profile.givenName);
                const lastName = JSON.stringify(userObj.profile.sn);
                setUser({
                    name: userObj.profile.givenName +' '+ userObj.profile.sn,
                    email: ''+userObj.profile.mail+'',
                    abbreviation: firstName[1] + lastName[1],
                    token: userObj.access_token
                });
            }
        });
    };
    return (
        <>
            
            <NavBar style={{gap:'0px'}}
                pectenArea='none'
                avatarArea={<Avatar abbreviation={user.abbreviation} label={ user.name } secondaryLabel={user.email}  dropdownOverlay={MenuOverlay} />}
            >
                <Section style={{paddingTop:'8px'}}>
                    <img src='/logo3.png' alt='Shell Aviation AIMS' style={{height:'88%', paddingLeft:'20px'}} title="Airport Interface Management System"/>
                </Section>

                <HorizontalMenu user={props.user} permissions={props.permissions}/>
                
                <ButtonLink href={Constants.helpSupportURL} target="_blank" aria-label="Help and support link"><Icons.QuestionMarkCircleSolid /></ButtonLink>
            </NavBar>
        </>
    )
}
